import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';

const Container = styled.p`
  color: ${props => props.theme.secondaryColor};
  margin: 8px 0;
  font: ${props => props.theme.fontWeightBold} 19px/100% ${props => props.theme.fontFamilyBody};

  ${props => props.theme.isMobile && `
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    & > span:nth-child(2) {
      margin-top: 6px;
    }
  `};
`;

export default function Career({ position, organization }) {
  const { isMobile } = React.useContext(ThemeContext);

  if (!position && !organization) {
    return null;
  }

  return (
    <Container>
      {
        isMobile
          ? (
            <>
              {!!position && <span>{position}</span>}
              {!!organization && <span>{organization}</span>}
            </>
          )
          : <>{_.compact([position, organization]).join(' \u2022 ')}</>
      }
    </Container>
  );
}

Career.propTypes = {
  position: PropTypes.string,
  organization: PropTypes.string,
};

Career.defaultProps = {
  position: null,
  organization: null,
};
